import React, { useEffect, useState } from 'react';

import { io } from "socket.io-client";
window.io = io;

const DEFAULT_CONTEXT = {
  connected: false,
  socket: undefined,
};

const SocketContext = React.createContext(DEFAULT_CONTEXT);

const SocketProvider = ({ children }) => {
  const [ context, setContext ] = useState(DEFAULT_CONTEXT);

  useEffect(() => {
    //let socket = io('https://dev.www.camsoda.com:3333');
    //let socket = io('http://localhost:3333');
    //let socket = io('https://209.239.162.62:3333');
    let socket = io('https://slotmachine.sodabits.io');

//    let socket = {
//      on () {},
//      off () {},
//    }

    socket.on('connect', () => {
      setContext((ctx) => {
        return {
          ...ctx,
          socket,
          connected: true,
        };
      });
    });

    socket.on('disconnect', () => {
      setContext((ctx) => {
        return {
          ...ctx,
          connected: false,
        };
      });
    });

    socket.on('uid', (uid) => {
      setContext((ctx) => {
        return {
          ...ctx,
          uid,
        };
      });
    });
  }, []);

  return (
    <SocketContext.Provider value={context}>
      { children }
    </SocketContext.Provider>
  );
}

export {
  SocketContext,
  SocketProvider
};
